import '../css/page.css';
import { Accordion, Container, Row, Col } from 'react-bootstrap';

function Page6() {
  return (
    <div className='ContentWrapper' style={{ display: 'flex', justifyContent: 'center', height: 'auto', paddingBottom: '6rem', paddingTop: '2rem' }}>
      <Container>
        <Row>
          <Col xs={12} md={4}>
            <h2 className='MegaPageHeading' style={{ textAlign: 'left', whiteSpace: 'nowrap', fontSize: 'clamp(2rem, 3.5rem, 4rem)' }}>
              FAQs
            </h2> 
            {/* terrible imple but works ig */}
          </Col>
          <Col xs={12} md={8} style={{ paddingTop: '4rem' }}>
            <Accordion defaultActiveKey="0" style={{ width: '100%', textAlign: 'left' }}>
              <Accordion.Item eventKey="0" style={{ borderTopLeftRadius: '30px', borderTopRightRadius: '30px', overflow: 'hidden' }}>
                <Accordion.Header>What is Pathway AI?</Accordion.Header>
                <Accordion.Body>
                  Pathway AI is a platform that helps designed to help students make smarter academic decisions. Appliying to a university can be a daunting task, but Pathway AI is here to provide personalised help.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>How does Pathway AI work?</Accordion.Header>
                <Accordion.Body>
                Pathway AI analyses your academic background, interests, and preferences to suggest the best college and academic decisions. We use real-world data and machine learning algorithms to provide personalised insights.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Who is Pathway AI for?</Accordion.Header>
                <Accordion.Body>
                  Pathway AI is designed for high school and college students who need guidance on university admissions, scholarships, internships, and career planning
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3" style={{ borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', overflow: 'hidden' }}>
                <Accordion.Header>How can I get started with Pathway AI?</Accordion.Header>
                <Accordion.Body>
                Getting started is easy! Simply pre-register today to gain early access and enjoy exclusive benefits, including 30% off your first subscription when we launch. Sign up now to secure your spot!
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Page6;

// TODO: A page specifically for more detailed features, the comparison feature
// take your next step with confidence